import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { listTrackingEvent } from 'app/utils/statistics/customEvents';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import get from '../../utils/get';
import { createImageProxyTemplate, formatImageProxyUrl } from '../../utils/svtimage';
import AccessibilityLinks from '../AccessibilityLinks/AccessibilityLinks';
import PlayButton from '../PlayButton/PlayButton';
import { GridItem, GridWrapper, Heading, LinkToAll, BumpingArrowIcon } from './PromotionGrid.styles';

const PromotionGrid = ({ title, mainGenres, showAccessibilityLinks = false, withDivider, className }) => {
    const classes = classNames(className, 'lp_clust');

    const onAllGenresClick = (e) => {
        const eventData = {
            listID: 'kategorilista',
            listType: 'kategorier',
            listItemIndex: mainGenres.length + 1,
            listExpandedState: true,
            contentId: 'alla',
        };

        trackCustomEvent(listTrackingEvent(eventData, e.currentTarget));
    };

    return (
        <GridWrapper className={classes} aria-label="Genrer" withDivider={withDivider}>
            {title && <Heading>{title}</Heading>}
            <AccessibilityLinks isVisible={showAccessibilityLinks} />
            {mainGenres.map((item, i) => {
                const promoItem = {
                    urlPart: `/genre/${item.id}`,
                    posterImageUrl: item.image
                        ? formatImageProxyUrl(
                              createImageProxyTemplate(item.image.id, item.image.changed),
                              'medium',
                              480
                          )
                        : '',
                    posterAltText: get(item, 'image.description', ''),
                    name: item.name,
                };

                return <GridItem item={promoItem} key={i} index={i + 1} expanded />;
            })}
            <LinkToAll data-rt="promotion-item">
                <PlayButton isCentered to="/genre" onAfterClick={(e) => onAllGenresClick(e)}>
                    Visa alla genrer <BumpingArrowIcon aria-hidden="true" />
                </PlayButton>
            </LinkToAll>
        </GridWrapper>
    );
};

PromotionGrid.propTypes = {
    title: PropTypes.string,
    mainGenres: PropTypes.arrayOf(PropTypes.object).isRequired,
    showAccessibilityLinks: PropTypes.bool,
};

export default PromotionGrid;
